import React, {useState, Suspense} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import UI from "components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import TbComFile from "domain/main/com/file/TbComFile";
import UIUtils from "utils/UIUtils";

function ContentsContainer() {
    const history = useHistory();
    const location = useLocation();
    const receivedData = (location.state as any)?.data;

    // 상세
    const [boardDetail, setBoardDetail] = useState<any>([]);
    const [notiStsCd, setNotiStsCd] = useState('');
    const [notiTitle, setNotiTitle] = useState('');
    const [notiCont, setNotiCont] = useState('');
    const [divNm, setDivNm] = useState('');
    const [notiTpCd, setNoTpCd] = useState('F');
    const notiNo = receivedData.NOTI_NO;
    const [personNm, setPersonNm] = useState('');
    const [retCnt, setRetCnt] = useState(0);
    const [regDate, setRegDate] = useState(new Date());

    // 파일
    const [fileId,setFileId] = useState('관리자');
    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
    const [loadFinish,setLoadFinish] = useState(false);

    //파일정보 선언
    const [notiFileValueTemp, setNotiFileValue] = useState(new TbComFile());
    const notiFileValue = React.useDeferredValue(notiFileValueTemp);

    // 폼체크 여부
    const [formCheck,setFormCheck] = useState(false);

    //파일업로드
    const [uploadId, setUploadId] = React.useState("");

    //파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    //파일업로드 완료
    const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
        console.log("arrayNew " ,JSON.stringify(arrayNew));

        let fileInfos : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        }[] = [];

        let fileInfo : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_GB:string;
            FILE_STATUS:string;
        };

        //파일등록 정보
        arrayNew?.map((item, index) => {
            if(item.status =="complete"){
                fileInfo = {
                    FILE_DETAIL_ID:item.uniqKey,
                    ORGINL_FILE_NM:item.originalName,
                    STRE_FILE_NM:item.uploadName,
                    FILE_SIZE:item.size,
                    STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                    FILE_EXTSN:item.extension,
                    FILE_GB:"FILE",
                    FILE_STATUS:"ADD"
                }

                fileInfos.push(fileInfo);
            }

            console.log("fileInfos : "+JSON.stringify(fileInfos));
        })

        //파일등록 정보
        arrayDel?.forEach((item, index) => {
            fileInfo = {
                FILE_DETAIL_ID:item.uniqKey,
                ORGINL_FILE_NM:item.originalName,
                STRE_FILE_NM:item.uploadName,
                FILE_SIZE:item.size,
                STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                FILE_EXTSN:item.extension,
                FILE_GB:"FILE",
                FILE_STATUS:"DEL"
            }

            fileInfos.push(fileInfo);

        })
        setFileInfoList(fileInfos);
    }

    // 파일 업로드
    const onFileUpload = () => {
        if(uploadId){
            window["RAONKUPLOAD"].Transfer(uploadId);
        }
    }

    //초기 데이터 설정
    let data = {};
    let param = {};

    const handleSelect = (e) => {
       if(e.target.name === 'notiStsCd'){
            setNotiStsCd(e.target.value);
       }
    };

    // 상세 이동
    async function onClickDetail(event) {
        event.preventDefault();
        let dataToSend = {NOTI_NO : notiNo};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './adm5211',
          state: { data: dataToSend }
        });
    };

    // 목록 이동
    async function onClickList(event) {
        event.preventDefault();
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './adm5210',
        });
    };

    // 상세 조회
    async function getRead() {
        const response:any = await CommonUtil.execute({
                url: "adm_5110.jct",
                data: {NOTI_NO: notiNo}
        })
        .then((response: any) => {
            setNotiTitle(response.NOTI_TITLE);
            setNotiStsCd(response.NOTI_STS_CD);
            setNotiCont(response.NOTI_CONT);
            setPersonNm(response.PERSON_NM);
            setRetCnt(response.RET_CNT);
            setRegDate(response.REG_DATE);
            setFileId(response.FILE_ID);
            setBoardDetail(response);
            const result = response;

            if(result.FILE_INFO.length > 0){
                let notiFileInfo = result.FILE_INFO;
                //파일등록 정보
                if (notiFileInfo) {
                    const tempTbComFile = new TbComFile();
                    notiFileInfo?.forEach((notiFileDetail, index) => {
                        const tbComFileMapngDetail = new TbComFileMapngDetail();
                        tbComFileMapngDetail.setDwldId(notiFileDetail.DWLD_ID);
                        tbComFileMapngDetail.setFileDetailId(notiFileDetail.FILE_DETAIL_ID);
                        tbComFileMapngDetail.setFilePolicy(notiFileDetail.FILE_POLICY);
                        tbComFileMapngDetail.setFileRpstr(notiFileDetail.FILE_RPSTR);
                        tbComFileMapngDetail.setStrePath(notiFileDetail.STRE_PATH);
                        tbComFileMapngDetail.setStreFileNm(notiFileDetail.STRE_FILE_NM);
                        tbComFileMapngDetail.setOrginlFileNm(notiFileDetail.ORGINL_FILE_NM);
                        tbComFileMapngDetail.setFileExtsn(notiFileDetail.FILE_EXTSN);
                        tbComFileMapngDetail.setFileSize(Number(notiFileDetail.FILE_SIZE));
                        tbComFileMapngDetail.setRegistDt(new Date(notiFileDetail.REGIST_DT));
                        tbComFileMapngDetail.setRegistPsnNm(notiFileDetail.REGIST_PSN_NM);

                        tempTbComFile.putTbComFileMapngDetailList(tbComFileMapngDetail);
                    })
                    setNotiFileValue(tempTbComFile);
                }
            }
            setLoadFinish(true);

        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });
    }


    // FAQ 수정 파일 업로드
    async function notiFormCheck() {

        // 필수값 체크
        if(notiTitle == ''){
            UIUtils.alert("제목을 입력해주세요.").then();
            return;
        }
        if(notiCont == ''){
            UIUtils.alert("내용을 입력해주세요.").then();
            return;
        }

        if(await UIUtils.confirm('수정하시겠습니까?')){

            setFormCheck(true);
            // 파일 업로드
            onFileUpload();
        }
    };

    // FAQ 내용 저장
    async function notiSave(sendParam:any){

        const response:any = await CommonUtil.execute({
            url:"adm_5130.jct",
            data: sendParam
        });

        // 완료 후 상세화면으로 이동
        let dataToSend = {NOTI_NO: notiNo};
        history.push({
            pathname: './adm5211',
            state: { data: dataToSend }
        });
    };

    // 파일 업로드 성공여부 체크
    React.useEffect(() => {
        if(fileInfoList && formCheck) {
            // 파일 업로드 성공
            let param ={
                NOTI_NO : notiNo,
                NOTI_TP_CD : notiTpCd,
                NOTI_TITLE : notiTitle,
                NOTI_STS_CD : notiStsCd,
                NOTI_CONT : notiCont,
                FILE_ID : fileId,
                FILE_INFO_LIST:fileInfoList.length>0?fileInfoList:null,
            }

            console.log("param : "+JSON.stringify(param));

            //내용 저장
            notiSave(param);

        }
    }, [fileInfoList])

    React.useEffect(() => {

        getRead();

    }, []);//effect

    if(!loadFinish)
        return (
            <PageLoading />
        )
    else
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">게시판관리</Link></li>
					<li><Link to="#">FAQ관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">FAQ 수정</h1>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={notiTitle} placeholder={''} valueChanged={(value) => setNotiTitle(value)} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">게시상태</p>
								<div className="fo-value">
									<div className="sl sl-md w375">
										<select name="notiStsCd" id="notiStsCd" defaultValue={notiStsCd} className="" onChange={handleSelect}>
                                            <option value="Y">보임</option>
                                            <option value="N">숨김</option>
                                        </select>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<UISunEditor value={notiCont} valueChanged={(value) => setNotiCont(value)} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={boardDetail.PERSON_NM} placeholder={''} readOnly={true}/>
								</div>
							</div>
						
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={DateUtil.toDateFormat(boardDetail.REG_DATE, "YYYY-MM-DD")} placeholder={''} readOnly={true}/>
								</div>
							</div>
						
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">조회수</p>
								<div className="fo-value">
									<UIInput  className={'tf tf-md w375'} value={boardDetail.RET_CNT} placeholder={''} readOnly={true}/>
								</div>
							</div>							
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
								    <div className='w100p'>
                                        <Suspense fallback={<PageLoading/>}>
                                            <UI.FileUpload
                                                onCreationComplete={onCreationComplete}
                                                onUploadComplete={onUploadComplete}
                                                attrs={{
                                                    ImgPreView: "99",
                                                    Views: "thumbs"
                                                }}
                                                value={notiFileValue}
                                            />
                                        </Suspense>
									</div>
								</div>
							</div>							

						</div> 
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={onClickDetail}>취소</Button>
                        <Button color="pri-o" size="sm" onClick={notiFormCheck}>저장</Button>
                        <Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>					
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;